export default __webpack_public_path__ + "static/media/Aura-Egg__84.5a412467.png";